import { useHistory } from "react-router-dom";
import { Button, Icon } from "semantic-ui-react";

import { ReactComponent as LicenseIcon } from "components/NotFoundPage/404-license-plate.svg";
import "components/NotFoundPage/NotFoundPage.scss";

export const NotFoundPage = () => {
  const history = useHistory();

  const navigate = () => {
    history.push("/");
  };
  return (
    <div className="NotFoundPage">
      <div className="NotFoundPage-overlay">
        <div className="NotFoundPage-container">
          <div className="NotFoundPage-action-buttons">
            <Button icon labelPosition="left" onClick={navigate}>
              <Icon className="arrow left" color="white" />
              Back to Homepage
            </Button>
          </div>
          <div className="NotFoundPage-car-repair">
            <div className="NotFoundPage-svg-icon">
              <LicenseIcon />
            </div>
            <div className="NotFoundPage-error-text">Page Not Found</div>
          </div>
        </div>
      </div>
    </div>
  );
};
